import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ValuePlaceholder } from '@openx/components-core/lib/Value/ValuePlaceholder/ValuePlaceholder.tsx';
import type { LookalikeSegmentSimilarityApi } from '@openx/types/segments.ts';
import { abbreviatedNumber } from '@openx/utils/lib/abbreviatedNumber.ts';
import { useTranslation } from 'react-i18next';
import { sortByPriority } from '../../utils/sortByPriority.ts';

type Props = {
  similarities: LookalikeSegmentSimilarityApi[];
};

export const ReachCell = ({ similarities }: Props) => {
  const { t } = useTranslation();
  const sortedSimilarities = sortByPriority(similarities);

  if (similarities.length === 0) {
    return <ValuePlaceholder dataTestParam="lal-reach-cell" />;
  }

  return (
    <Box data-test="lal-reach-cell">
      {sortedSimilarities.map(({ similarity_level, segment }) => (
        <Typography key={similarity_level} variant="body2">
          <Typography component="span" color="textSecondary" sx={{ marginRight: 1 }}>
            {t(similarity_level)}:
          </Typography>
          {segment.reach ? abbreviatedNumber(segment.reach) : <ValuePlaceholder />}
        </Typography>
      ))}
    </Box>
  );
};
